export default "assets/images/quote-background-015be261.jpg";